/* tslint:disable */
/* eslint-disable */
// Generated by Microsoft Kiota
// @ts-ignore
import { createCrewBriefingTemplateFromDiscriminatorValue, createProblemDetailsFromDiscriminatorValue, createValidationProblemDetailsFromDiscriminatorValue, type CrewBriefingTemplate, type ProblemDetails, type ValidationProblemDetails } from '../../models/index.js';
// @ts-ignore
import { type WithFileNameItemRequestBuilder, WithFileNameItemRequestBuilderRequestsMetadata } from './item/index.js';
// @ts-ignore
import { MultipartBody, serializeMultipartBody, type BaseRequestBuilder, type KeysToExcludeForNavigationMetadata, type NavigationMetadata, type Parsable, type ParsableFactory, type RequestConfiguration, type RequestInformation, type RequestsMetadata } from '@microsoft/kiota-abstractions';

/**
 * Builds and executes requests for operations under /Charter/CrewBriefingTemplates
 */
export interface CrewBriefingTemplatesRequestBuilder extends BaseRequestBuilder<CrewBriefingTemplatesRequestBuilder> {
    /**
     * Gets an item from the ApiSdk.Charter.CrewBriefingTemplates.item collection
     * @param fileName Unique identifier of the item
     * @returns {WithFileNameItemRequestBuilder}
     */
     byFileName(fileName: string) : WithFileNameItemRequestBuilder;
    /**
     * @param requestConfiguration Configuration for the request such as headers, query parameters, and middleware options.
     * @returns {Promise<CrewBriefingTemplate[]>}
     * @throws {ProblemDetails} error when the service returns a 401 status code
     * @throws {ProblemDetails} error when the service returns a 403 status code
     */
     get(requestConfiguration?: RequestConfiguration<object> | undefined) : Promise<CrewBriefingTemplate[] | undefined>;
    /**
     * @param body The request body
     * @param requestConfiguration Configuration for the request such as headers, query parameters, and middleware options.
     * @returns {Promise<CrewBriefingTemplate>}
     * @throws {ValidationProblemDetails} error when the service returns a 400 status code
     */
     post(body: MultipartBody, requestConfiguration?: RequestConfiguration<object> | undefined) : Promise<CrewBriefingTemplate | undefined>;
    /**
     * @param requestConfiguration Configuration for the request such as headers, query parameters, and middleware options.
     * @returns {RequestInformation}
     */
     toGetRequestInformation(requestConfiguration?: RequestConfiguration<object> | undefined) : RequestInformation;
    /**
     * @param body The request body
     * @param requestConfiguration Configuration for the request such as headers, query parameters, and middleware options.
     * @returns {RequestInformation}
     */
     toPostRequestInformation(body: MultipartBody, requestConfiguration?: RequestConfiguration<object> | undefined) : RequestInformation;
}
/**
 * Uri template for the request builder.
 */
export const CrewBriefingTemplatesRequestBuilderUriTemplate = "{+baseurl}/Charter/CrewBriefingTemplates";
/**
 * Metadata for all the navigation properties in the request builder.
 */
export const CrewBriefingTemplatesRequestBuilderNavigationMetadata: Record<Exclude<keyof CrewBriefingTemplatesRequestBuilder, KeysToExcludeForNavigationMetadata>, NavigationMetadata> = {
    byFileName: {
        requestsMetadata: WithFileNameItemRequestBuilderRequestsMetadata,
        pathParametersMappings: ["fileName"],
    },
};
/**
 * Metadata for all the requests in the request builder.
 */
export const CrewBriefingTemplatesRequestBuilderRequestsMetadata: RequestsMetadata = {
    get: {
        uriTemplate: CrewBriefingTemplatesRequestBuilderUriTemplate,
        responseBodyContentType: "text/plain;q=0.9",
        errorMappings: {
            401: createProblemDetailsFromDiscriminatorValue as ParsableFactory<Parsable>,
            403: createProblemDetailsFromDiscriminatorValue as ParsableFactory<Parsable>,
        },
        adapterMethodName: "sendCollection",
        responseBodyFactory:  createCrewBriefingTemplateFromDiscriminatorValue,
    },
    post: {
        uriTemplate: CrewBriefingTemplatesRequestBuilderUriTemplate,
        responseBodyContentType: "application/json",
        errorMappings: {
            400: createValidationProblemDetailsFromDiscriminatorValue as ParsableFactory<Parsable>,
        },
        adapterMethodName: "send",
        responseBodyFactory:  createCrewBriefingTemplateFromDiscriminatorValue,
        requestBodyContentType: "multipart/form-data",
        requestBodySerializer: serializeMultipartBody,
        requestInformationContentSetMethod: "setContentFromParsable",
    },
};
/* tslint:enable */
/* eslint-enable */
